<template>
    <div class="w-80 px-7 pb-5 mx-auto">
        <!-- Spinner pendant le chargement -->
        <spinner class="text-center mt-8 mb-8" v-if="loading" style="height: 200px">
            <div>
                <span class="mt-4">
                    <Spinner></Spinner>
                </span>
            </div>
        </spinner>

        <!-- Contenu une fois les données chargées -->
        <div v-else>
            <div
                v-if="claims2 && claims2.data && claims2.data.length > 0 && (claims2.data[0].status === 0 || claims2.data[0].status === 1)">
                <!-- Status 0: En attente -->
                <div v-if="claims2.data[0].status === 0" class="card mt-5 ">
                    <div class="card-body text-center ext-light fw-bold py-7">
                        <i class="bi bi-hourglass-split text-warning fs-2 mb-3"></i>
                        <h5>{{ $t("transfer.claim_status_pending1") }}</h5>
                    </div>
                </div>

                <!-- Status 1: En cours de traitement -->
                <div v-else-if="claims2.data[0].status === 1" class="card mt-5">
                    <div class="card-body text-center ext-light fw-bold py-7">
                        <i class="bi bi-arrow-repeat text-info fs-2 mb-3"></i>
                        <h5>{{ $t("transfer.claim_status_processing1") }}</h5>
                    </div>
                </div>
            </div>
            <div class="content text-center" v-else>
                <i class="fas fs-1 fa-exclamation-triangle text-warning mb-2" style="font-size: 2rem;"></i>
                <h5 class="modal-title mt-4 mb-3">Modifier les informations bancaires </h5>
                <p> </p>
                <drop-zone @change="selectedFile" @drop.prevent="drop"></drop-zone>
                <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
            </div>

        </div>
        <!-- Modal de prévisualisation -->
        <div class="modal" v-if="showPreviewModal" tabindex="-1" style="display: block; background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="card">
                        <div class="modal-header" style="border-bottom: 1px solid rgba(250,250,250,0.5);">
                            <h6 class="modal-title">{{ $t("transfer.no_bank_docs_modal") }} </h6>

                            <button type="button" class="btn-close" @click="closePreviewModal"></button>
                        </div>
                        <div class="modal-body">
                            <!-- Prévisualisation PDF -->
                            <embed v-if="selectedFileType === 'application/pdf'" :src="previewUrl"
                                type="application/pdf" width="100%" height="500px" />

                            <!-- Prévisualisation Image -->
                            <img v-if="selectedFileType.includes('image')" :src="previewUrl" class="img-fluid"
                                alt="Prévisualisation" />
                        </div>
                        <div class="modal-footer" style="border-top: 1px solid rgba(250,250,250,0.5);">

                            <argon-button type="button" data-bs-dismiss="modal" class="btn bg-transparent"
                                @click="closePreviewModal"
                                style="width: 150px; height: 50px; padding-top: 15px ;border:1px solid rgba(255, 255, 255, 0.4);">
                                {{ $t("button.cancel") }}
                            </argon-button>

                            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="danger"
                                variant="gradient" type="button" class="mt-1"
                                style="width: 150px; height: 50px; padding-top: 15px" @click="confirmeuplaod">
                                <span v-if="!loading">{{ $t("button.upload") }}</span>
                            </argon-button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DropZone from "@/components/DropZone";
import api_config from "@/config";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ArgonButton from "@/components/ArgonButton";
import Spinner from "@/components/Spinner";
import { uploadbankdoc, submit_claims_bank_information, getCleams } from "@/utils/services";

export default {
    name: 'Update-Bank-Certificate',
    data() {
        return {
            school_name: "",
            xpay_connection_id: localStorage.getItem('xpay_connection_id'),
            config_id: localStorage.getItem('configID'),
            name: localStorage.getItem('name'),
            errorMessage: "",
            allowedTypes: [
                'application/pdf',
                'image/jpeg',
                'image/jpg',
                'image/png'
            ],
            fileURL: null,
            isValidFile: false,
            successMessage: "",
            showPreviewModal: false,
            previewUrl: null,
            selectedFileType: "",
            selectedFileData: null,
            showConfirmation: false,
            loading: false,
            preview: '',
            claims2: [],
            bank_information: ''
        }
    },

    components: {
        DropZone,
        ArgonButton,
        Spinner
    },

    props: {
        amount: {
            type: Boolean,
            required: true
        },
        installmentNumber: {
            type: Boolean,
            required: true
        },
        due_date: {
            type: Boolean,
            required: true
        },
        close1: {
            type: Function,
            required: true,
        },
        sendinvoice: {
            type: Function,
            required: true,
        },
        refreshComponentData: {
            type: Function,
            required: true,
        }
    },

    methods: {

        closePreviewModal() {
            this.showPreviewModal = false;
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = null;
            }
        },

        selectedFile(event) {
            const file = event.target.files[0];
            if (file) {

                this.upload(file);

                this.validateAndProcessFile(file);
            }
        },


        drop(event) {
            event.preventDefault();
            const files = event.dataTransfer.files;
            if (files && files.length > 0) {

                this.upload(files[0]);

                this.validateAndProcessFile(files[0]);
            }
        },


        async validateAndProcessFile(file) {
            if (!file) return;

            this.errorMessage = "";
            this.successMessage = "";

            if (!this.allowedTypes.includes(file.type)) {
                this.errorMessage = "Seuls les fichiers PDF et images (JPG, JPEG, PNG) sont acceptés";
                return;
            }

            const maxSize = 5 * 1024 * 1024; // 5MB en octets
            if (file.size > maxSize) {
                this.errorMessage = "Le fichier est trop volumineux. La taille maximale est de 5MB";
                return;
            }


            this.previewUrl = URL.createObjectURL(file);
            this.selectedFileType = file.type;
            this.selectedFileData = file;
            this.showPreviewModal = true;
        },


        async upload(file) {
            try {
                this.loading = true;

                const uploadData = {
                    selectedFile: file,

                };

                const response = await uploadbankdoc(uploadData);

                if (response) {
                    console.log("Document uploaded successfully");
                    this.fileURL = response.url;
                    this.preview = response.preview;
                    localStorage.setItem('preview', this.preview);
                    this.successMessage = this.$t('fees_modal.success_title');
                }
            } catch (error) {
                console.error("Error uploading document:", error);
                this.errorMessage = this.$t('errors.download_file_error');
            } finally {
                this.loading = false;
            }
        },
        async confirmeuplaod() {
            if (this.loading || !this.fileURL) return;

            try {
                this.loading = true;
                this.buttonActive = true;

                const response = await submit_claims_bank_information(
                    'appConfig',
                    api_config.UPDATE_BANK_INFORMATION_TITLE,
                    this.name,
                    this.xpay_connection_id,
                    this.fileURL
                );

                if (response) {
                    const message = this.$t("fees_modal.success_title");
                    toast.success(message, {
                        autoClose: 3000,
                    });

                    setTimeout(() => {

                        this.transfer_min_amount = this.selectedAmount;
                    }, 3000);
                }
            } catch (error) {
                console.error(this.$t('errors.claim_submission_error'), error);
            } finally {
                this.loading = false;
                this.buttonActive = false;
                this.closePreviewModal();
            }
        },

        async fetchgetclaimsbankinformation() {
            this.loading = true;
            const connection_id = this.xpay_connection_id;
            const type = "AppConfig";
            const title = api_config.UPDATE_BANK_INFORMATION_TITLE;

            try {
                let response = await getCleams(connection_id, type, title);
                this.claims2 = response || [];
                this.bank_information = this.claims2.data.map(claim => claim.data.bank_information);
            } catch (error) {
                console.error("Error fetching incorrect amount claims:", error);
            } finally {
                this.loading = false;
            }
        },
    },

    beforeUnmount() {

        if (this.previewUrl) {
            URL.revokeObjectURL(this.previewUrl);
        }
    },
    mounted() {
        this.fetchgetclaimsbankinformation();
    },
}
</script>

<style scoped>
.w-80 {
    width: 80%;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1050;
}

.modal-dialog {
    margin: 1.75rem auto;
}

.img-fluid {
    max-width: 100%;
    height: auto;
}
</style>